// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mnj4NxNL_1zBkk7CM9Kt{display:flex;align-items:center;justify-content:center;margin-left:8px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/TextField/ActionsAside/TextFieldLoading/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,eAAA","sourcesContent":[".loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `mnj4NxNL_1zBkk7CM9Kt`
};
export default ___CSS_LOADER_EXPORT___;
